// extracted by mini-css-extract-plugin
export default {"scrollContainer":"scrollContainer__VepSubmissions__5Lote","container":"container__VepSubmissions__5Lote"};